<template>
	<div class="sampleM">
		<p class="sampleM_header">
			<router-link tag="i" to="questionSetting?id=5" class="wjpc-iconfont wjpc-icon-arrow-left-bold"></router-link>
			<span>样本管理</span>
		</p>
		<div class="sampleM_bread">
			<span>样本配置</span>
			<router-link tag="span" to="SampleImport">
				<i
					class="wjpc-iconfont wjpc-icon-lianxirenicon-01
"
				></i>
				样本导入
			</router-link>
		</div>

		<div class="sampleM_content">
			<div class="sampleM_content_a">
				<div class="content_a_left">
					<label>
						用户名:
						<el-input v-model="a_left_name" @change="pageTable(a_left_name, a_left_phone, search)" type="text" />
					</label>
					<label>
						手机号:
						<el-input v-model="a_left_phone" @change="pageTable(a_left_name, a_left_phone, search)" type="text" />
					</label>
					<el-select v-model="answerState" placeholder="样本状态" @change="pageTable(a_left_name, a_left_phone, search, answerState)">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<span class="sampleM_content_a_input">
						<el-input class="a_input" v-model="search" @change="pageTable(a_left_name, a_left_phone, search)" type="text" placeholder="搜索样本编号" />
						<i
							class="wjpc-iconfont wjpc-icon-lianxirenicon-03
"
						></i>
					</span>
				</div>
				<span @click="empty">
					<i class="wjpc-iconfont wjpc-icon-lianxirenicon-04"></i>
					清空
				</span>
			</div>
			<!-- table 中区 -->
			<el-table
				class="sampleM_content_b"
				ref="multipleTable"
				:data="sampleMTableData"
				tooltip-effect="dark"
				border="border"
				header-row-class-name="thead-cell"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" max-width="40"></el-table-column>
				<el-table-column prop="id" label="样本编号"></el-table-column>
				<el-table-column prop="answerName" label="用户名" max-width="110"></el-table-column>
				<el-table-column prop="email" label="邮箱" width="180"></el-table-column>
				<el-table-column prop="cellPhone" label="手机号" max-width="120"></el-table-column>
				<el-table-column prop="answerSex" label="性别" width="56"></el-table-column>
				<el-table-column prop="answerAge" label="年龄" width="56"></el-table-column>
				<el-table-column prop="maritalStatus" label="婚姻状态" width="90"></el-table-column>
				<el-table-column prop="answerAddress" label="详细地址" width="250"></el-table-column>
				<el-table-column prop="position" label="职位" width="100"></el-table-column>
				<el-table-column prop="answerState" label="状态" width="130"></el-table-column>
				<el-table-column label="操作" width="240">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" type="primary" @click="looksampleM(scope.row)" round>查看样本</el-button>
							<el-button size="mini" type="success" round>
								<router-link :to="{ path: 'PaperDetails', query: { id: scope.row.id } }" tag="span">答卷详情</router-link>
							</el-button>
							<el-button size="mini" type="danger" @click="deletesampleM(scope.row)" round>删除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="sampleM_content_c">
				<el-pagination
					@current-change="CurrentChange1"
					:hide-on-single-page="page_value"
					:current-page.sync="currentPageIndex"
					:page-size="pageSize"
					:total="totals"
					layout="prev, pager, next, jumper"
				></el-pagination>
			</div>
		</div>
		<!--遮罩层 模态框 -->
		<div v-if="modalBox" class="modalBox"></div>
		<!-- 样本配置 -->
		<div class="sampleMBox" v-if="sampleMBox">
			<p>
				<span @click="tosampleM">
					<i class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"></i>
					返回样本配置
				</span>
				<span>样本编号:{{ sampleMBox_id }}</span>
			</p>
			<div class="sampleMBox_label">
				<label>
					用户名:
					<el-input type="text" v-model="sampleMBox_name" />
				</label>
				<!-- 	<label>
					身份证:
					<el-input type="text" v-model="sampleMBox_add"/>
				</label> -->
				<label>
					性别 :
					<el-input type="text" v-model="sampleMBox_sex" />
				</label>
				<label>
					年龄 :
					<el-input type="text" v-model="sampleMBox_age" />
				</label>
				<label>
					生日 :
					<el-input type="text" v-model="sampleMBox_day" />
				</label>
				<label>
					邮箱 :
					<el-input type="text" v-model="sampleMBox_email" />
				</label>
				<label>
					手机 :
					<el-input type="text" v-model="sampleMBox_phone" />
				</label>
				<label>
					婚姻 :
					<el-input type="text" v-model="sampleMBox_marital" />
				</label>
				<!-- <label>
					学历 :
					<el-input type="text" v-model="sampleMBox_xueli"/>
				</label> -->
				<label>
					职位 :
					<el-input type="text" v-model="sampleMBox_zhiwei" />
				</label>
				<!-- <label>
					公司 :
					<el-input type="text" v-model="sampleMBox_gonsi"/>
				</label> -->
				<br />
				<label>
					地址&ensp;:
					<el-input type="text" v-model="sampleMBox_dizhi" />
				</label>

				<label v-for="(item, index) in extendSampleDetaList" :key="index">
					{{ item.namme }}:
					<el-input type="text" v-model="item.content" />
				</label>
			</div>
		</div>
		<!-- 样本导入 -->
		<div></div>
		<!-- 删除 -->
		<div class="delsampleM" v-if="delsampleM">
			<h3>需要验证密码</h3>
			<el-input v-model="delsampleM_input" type="password" placeholder="请输入账户密码" />
			<div>
				<el-button type="danger" round @click="delsampledata">确认删除</el-button>
				<el-button type="info" round @click="undelete">取消删除</el-button>
			</div>
		</div>
		<!-- 清空 -->
		<div class="delsampleM" v-if="emptysample">
			<h3>需要验证密码</h3>
			<el-input v-model="emptysample_input" type="password" placeholder="请输入账户密码" />
			<div>
				<el-button type="danger" round @click="emptysampledata">确认清空</el-button>
				<el-button type="info" round @click="emptyundelete">取消清空</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 详细信息
			extendSampleDetaList: [],
			sampleMBox_id: '',
			delSampleMBoxId: '',
			sampleMBox_name: '',
			sampleMBox_add: '',
			sampleMBox_sex: '',
			sampleMBox_age: '',
			sampleMBox_day: '',
			sampleMBox_email: '',
			sampleMBox_phone: '',
			sampleMBox_marital: '',
			sampleMBox_xueli: '',
			sampleMBox_zhiwei: '',
			sampleMBox_gonsi: '',
			sampleMBox_dizhi: '',
			// 表格
			sampleMTableData: [],
			// 分页
			currentPageIndex: 1, //当前第几页,
			totals: 0, //总共多少条数据
			pageSize: 10, //一页显示几个
			// input↓
			answerState: '',
			search: '',
			a_left_phone: '',
			a_left_name: '',
			delsampleM_input: '',
			emptysample_input: '',
			// input绑定 ↑
			emptysample: false,
			delsampleM: false,
			sampleMBox: false,
			modalBox: false,
			page_value: false,
			multipleSelection: [], //选择复选框 有多个id的删除
			delete_ids: [], //不选单个 直接删除
			options: [
				{
					value: '0',
					label: '初始样本'
				},
				{
					value: '1',
					label: '进行中'
				},
				{
					value: '2',
					label: '读取'
				},
				{
					value: '3',
					label: '中断'
				},
				{
					value: '4',
					label: '无效答卷'
				},
				{
					value: '5',
					label: '配额已满'
				},
				{
					value: '6',
					label: '正常结束'
				}
			]
		};
	},
	mounted: function() {
		this.pageTable();
	},
	methods: {
		//清空 样本数据
		emptysampledata() {
			let that = this;
			that.modalBox = true;
			that.emptysample = true;
			let password = that.emptysample_input;
			let wid = sessionStorage.getItem('wid');
			let params = {
				that: this,
				url: this.$config.service.emptysampledata,
				method: 'post',
				data: {
					password: password,
					questionnaireId: wid
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success('清空成功');

						that.pageTable();
						that.modalBox = false;
						that.emptysample = false;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 删除 样本数据
		delsampledata() {
			let that = this;

			let wid = sessionStorage.getItem('wid');
			let password = that.delsampleM_input;
			if (that.delete_ids.length != 0) {
				var delete_ids = that.delete_ids;
			} else {
				var delete_ids = that.multipleSelection.map(item => item.id);
			}
			let params = {
				that: this,
				url: this.$config.service.delsampledata,
				method: 'post',
				data: {
					questionnaireId: wid,
					password: password,
					sampleContrastIdList: delete_ids
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.$message.success('删除成功');

						that.pageTable();
						that.delete_ids = [];
						that.modalBox = false;
						that.delsampleM = false;
					} else {
						that.$message.error(res.message);
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		// 分页
		// 前往第几页
		handleSizeChangesmp(val) {
			CurrentChange1(val);
		},
		// 上一页 下一页
		CurrentChange1(val) {
			let that = this;
			that.currentPageIndex = val;
			that.pageTable();
		},
		// 表格 及 搜索
		pageTable(a_left_name, a_left_phone, search, answerState) {
			let that = this;
			let wid = sessionStorage.getItem('wid');
			let params = {
				that: this,
				url: `${this.$config.service.querysampledatalistpage}?pageIndex=${that.currentPageIndex}&pageSize=${that.pageSize}`,
				method: 'post',
				data: {
					questionnaireId: wid,
					answerName: a_left_name,
					answerState: answerState,
					cellPhone: a_left_phone,
					sampleId: search
					// userId: string
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						let status_code = ['初始样本', '进行中', '读取', '中断', '无效答卷', '配额已满', '正常结束'];

						for (let i = 0; i < res.resultBody.datas.length; i++) {
							var a = res.resultBody.datas[i].answerState;
							res.resultBody.datas[i].answerState = status_code[a];
						}
						// 所有数据
						that.sampleMTableData = res.resultBody.datas;
						// 一共多少条数据
						that.totals = res.resultBody.total;
					} else {
						that.sampleMTableData = [];
					}
				}
			};
			this.$util.request(params);
		},
		handleSelectionChange(val) {
			let that = this;
			console.log('点击的是这行样本', val);
			that.multipleSelection = val;
		},

		// 清空 样本
		empty() {
			let that = this;
			that.modalBox = true;
			that.emptysample = true;
			that.emptysample_input = '';
		},
		// 取消清空样本
		emptyundelete() {
			let that = this;
			that.modalBox = false;
			that.emptysample = false;
			that.emptysample_input = '';
		},
		// 样本删除  单个
		deletesampleM(row) {
			let that = this;
			that.delsampleM_input = '';
			let delete_ids = [row.id];
			that.delete_ids = delete_ids;
			that.modalBox = true;
			that.delsampleM = true;
		},
		// 取消删除
		undelete() {
			let that = this;
			that.delsampleM_input = '';
			that.delete_ids = [];
			that.modalBox = false;
			that.delsampleM = false;
			that.delsampleM_input = '';
		},

		// 查看样本配置
		looksampleM(row) {
			this.delSampleMBoxId = row.id;
			let that = this;
			that.modalBox = true;
			that.sampleMBox = true;
			let params = {
				that: this,
				url: this.$config.service.queryonesampledata,
				method: 'post',
				data: {
					id: row.id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('查看单人样本配置', res.resultBody);
						that.sampleMBox_name = res.resultBody.answerName;
						that.sampleMBox_add = res.resultBody.answerAddress;
						that.sampleMBox_sex = res.resultBody.answerSex;
						that.sampleMBox_age = res.resultBody.answerAge;
						that.sampleMBox_day = res.resultBody.day ;
						that.sampleMBox_email = res.resultBody.email;
						that.sampleMBox_phone = res.resultBody.cellPhone;
						that.sampleMBox_marital = res.resultBody.maritalStatus;
						that.sampleMBox_xueli = res.resultBody.xueli;
						that.sampleMBox_zhiwei = res.resultBody.position;
						that.sampleMBox_gonsi = res.resultBody.gonsi;
						that.sampleMBox_dizhi = res.resultBody.answerAddress;
						that.sampleMBox_id = res.resultBody.id;
						that.extendSampleDetaList = res.resultBody.extendSampleDetaList;
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 返回样本配置
		tosampleM() {
			let that = this;
			that.modalBox = false;
			that.sampleMBox = false;
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		}
	}
};
</script>

<style lang="scss">
html {
	background-color: #f5f5f5;
}
.sampleM {
	width: 100%;
	height: 100%;
	background-color: #f5f5f5;
	// 头部
	.sampleM_header {
		height: 68px;
		background-color: #fff;
		text-align: center;
		line-height: 68px;
		i {
			float: left;
			margin-left: 30px;
			font-size: 16px;
		}
		span {
			font-size: 16px;
			color: #333;
		}
	}
	//样本配置
	.sampleM_bread {
		max-width: 1600px;
		height: 69px;
		line-height: 69px;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			&:nth-child(1) {
				font-size: 16px;
				color: #333333;
			}
			&:nth-child(2) {
				float: right;
			}
		}
	}
	// 内容 table 上中下
	.sampleM_content {
		max-width: 1600px;
		background-color: #fff;
		margin: auto;
		// 上 input
		.sampleM_content_a {
			max-width: 1550px;
			height: 85px;
			line-height: 85px;
			display: flex;
			justify-content: space-around;
			.content_a_left {
				flex: 1;
				margin-left: 12px;
				label {
					margin-left: 18px;
					.el-input {
						max-width: 160px;
						height: 32px;
						margin-left: 5px;
					}
				}
				.el-select {
					margin-left: 25px;
					max-width: 110px;
					height: 32px;
				}
				.sampleM_content_a_input {
					margin-left: 35px;
					position: relative;
					.a_input {
						width: 310px;
						height: 32px;
					}
					i {
						font-size: 22px;
						position: absolute;
						right: 20px;
					}
				}
			}
			span:nth-child(5) {
				font-size: 14px;
				color: #666;
				i {
					font-size: 20px;
				}
			}
		}
		// 中 table
		.sampleM_content_b {
			max-width: 1550px;
			margin: auto;

			.thead-cell > th {
				background-color: #f5f5f5;
				.cell {
					text-align: center;
				}
			}
			.el-table__row > td {
				text-align: center;
			}
		}
		// 下 分页
		.sampleM_content_c {
			max-width: 1550px;
			margin: auto;
			.el-pagination {
				width: 582px;
				height: 32px;
				margin: auto;
				text-align: center;
				padding-bottom: 51px;
				margin-top: 20px;
			}
		}
	}
	//  遮罩层
	.modalBox {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1001;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.3;
	}
	/*模态框*/
	.sampleMBox {
		position: fixed;
		background: #fff;
		width: 1200px;
		height: 746px;
		opacity: 1;
		z-index: 2001;
		top: 10%; /*偏移*/
		left: 50%;
		margin-left: -600px;
		p {
			height: 80px;
			line-height: 80px;
			display: flex;
			justify-content: space-between;
			span:nth-child(1) {
				margin-left: 26px;
			}
			span:nth-child(2) {
				margin-right: 50px;
			}
		}
		.sampleMBox_label {
			height: 490px;
			margin-left: 44px;
			display: flex;
			// flex-direction:row;
			flex-wrap: wrap; //是否换行
			justify-content: space-around;
			label {
				height: 34px;
				.el-input {
					width: 300px;
					height: 34px;
				}
			}
			// label:nth-child(odd) {
			// 	min-width: 650px;
			// }
			// label:nth-child(even) {
			// 	flex: 1;
			// }
			// label:nth-child(11),
			// label:nth-child(13) {
			// 	input {
			// 		width: 896px;
			// 		height: 76px;
			// 	}
			// }
		}
	}
	// 删除
	.delsampleM {
		position: fixed;
		background: #fff;
		width: 500px;
		height: 200px;
		opacity: 1;
		z-index: 2001;
		top: 25%; /*偏移*/
		left: 50%;
		margin-left: -250px;
		text-align: center;
		.el-input {
			width: 250px;
			height: 50px;
		}
		div {
			.el-button {
				margin-top: 20px;
			}
		}
	}
}
</style>
